
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commandzone",
      function () {
        return require("private-next-pages/commandzone/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commandzone"])
      });
    }
  